/**
 * useProducerPilot — convenience hook wrapping useAppSettings
 * with pilot mode defaults.
 */
import { useAppSettings } from './useAppSettings';
import { PILOT_SETTINGS_KEYS, PILOT_DEFAULTS } from '@/config/producerPilot';

export function useProducerPilot() {
  const { settings, get, isLoading } = useAppSettings(
    [...PILOT_SETTINGS_KEYS],
    PILOT_DEFAULTS,
  );

  const isPilot = get<boolean>('producer_portal.pilot_mode', true);

  /** Check if a feature is visible (always true when pilot mode is off) */
  function isFeatureVisible(key: string): boolean {
    if (!isPilot) return true;
    return get<boolean>(key, false);
  }

  return { isPilot, isFeatureVisible, settings, isLoading };
}
